import PaymentsField from '@apps/finance/admin/components/paymentsfield'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import moment from 'moment'
import React from 'react'

class New extends React.Component {

  static contextTypes = {
    modal: PropTypes.object,
    router: PropTypes.object
  }

  static propTypes = {
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form {...this._getForm()} />
  }

  _getForm() {
    return {
      title: 't(New Deposit)',
      method: 'POST',
      action: '/api/admin/finance/deposits',
      successText: 'Save',
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { label: 't(Date)', name: 'date', type: 'datefield', required: true, defaultValue: moment().format('YYYY-MM-DD') },
            { label: 't(Bank Account)', name: 'bank_id', type: 'lookup', endpoint: '/api/admin/finance/banks', valueKey: 'id', textKey: 'title', required: true },
            { label: 't(Transactions)', name: 'transactions', type: PaymentsField, required: true }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleSuccess(deposit) {
    this.context.router.push(`/finance/deposits/${deposit.id}`)
    this.context.modal.close()
  }

}

export default New
